// ------------------------------------
// props 輸入需求 : 
// props.hide : function( void )                    ( 開關按鈕 )
// props.data : object : { data: array }            (  )
// ------------------------------------
import React from 'react'
import { useTranslation } from 'react-i18next';
import '../../add/_add.scss'
import AddUsersADMIN from './AddUsersADMIN';
import ResetUserAdmin from './ResetUserAdmin';

const AddPageFrameADMIN =(props)=>{
    const { t } = useTranslation()
    return(
        <div className="pos-f z-1 wid-full hig-full top-0 left-0 fx-ccc bg-black" onClick={props.hide}>
            <div className="layout-history fx-d-c pad-30 l r" onClick={e=>e.stopPropagation()}>
                <div className="h-15 fx-d-r font-m">
                    <div className="w-30 font-xl fx-ccc">
                        {(props.type[0]==="add")? t("AUDIT_TRAIL.EVENTS.CREATE_USER"):t("ADMIN.MODIFY_CAREGIVER")}
                    </div>
                    {/* close btn */}
                    <div className='w-60'></div>
                    <div className="fx-2 fx-nfen" onClick={props.hide}>
                        <div className="cross dark fx-ccc cursor pt"></div>
                    </div>
                    {/* close btn */}
                </div>
                <div className="h-85 fx-d-c w-100">
                    {(props.type[0]==="add")? <AddUsersADMIN hide={props.hide} toggleRefresh={props.toggleRefresh}/>
                    :<ResetUserAdmin hide={props.hide} toggleRefresh={props.toggleRefresh} user={props.type[1]}/>}
                </div>
            </div>
        </div>
    );	

}
export default AddPageFrameADMIN;